import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { getBlsKeyByReturnUrl } from 'helpers/bls';
import SessionStorage from 'libs/SessionStorage';
import OidcService from 'services/OidcService';
import { SwitchIdentity } from 'modules/Account';
import { LogoLayout } from 'modules/Layout';
async function action({ route, fullPath, bls }) {
    let Component = null;
    let isAuthenticated = false;
    if (process.env.BROWSER) {
        const user = await OidcService.getUser();
        if (user) {
            isAuthenticated = true;
            let blsKey;
            const blsReturnUrl = SessionStorage.getItem('blsReturnUrl');
            if (blsReturnUrl) {
                const url = new URL(blsReturnUrl);
                if (url) {
                    blsKey = getBlsKeyByReturnUrl(bls, blsReturnUrl);
                }
            }
            Component = /*#__PURE__*/ _jsx(SwitchIdentity, {
                blsKey: blsKey
            });
        } else {
            SessionStorage.setItem('returnPath', fullPath);
            await OidcService.login();
        }
    }
    return {
        chunks: [
            'account'
        ],
        name: route.name,
        component: /*#__PURE__*/ _jsx(LogoLayout, {
            isAuthenticated: isAuthenticated,
            children: Component
        })
    };
}
export default action;
